module.exports = __webpack_public_path__ + "assets/img/logo (1).978da291.png";